module.exports = __webpack_public_path__ + "static/media/polaroid-14.ed39083f.png";